import React, { useState, useEffect, useRef } from 'react';

import { IMissingLetterSearch } from './interface';
import { Row, Column } from 'components/Layout/Grid';
import Text from 'components/Text';
import { Button } from 'components/Button';

import IconSearch from 'img/search-icon.svg';

import {
  addKeyPressListener,
  removeKeyPressListener,
} from 'utils/searchWithEnterPress';
import { IFoulLetterFilterViewModel } from 'models/MissingLetter';

const MissingLetterSearch: React.FC<IMissingLetterSearch> = (props) => {
  const { setTableFilter, setCurrentPage } = props;

  const randomTableSearchId = `${Math.floor(Math.random() * 1000)}`;

  const [productSearchStr, setProductSearchStr] = useState('');
  const [codeSearchStr, setCodeSearchStr] = useState('');
  const [supplierSearchStr, setSupplierSearchStr] = useState('');

  const productSearchStrRef = useRef(productSearchStr);
  const codeSearchStrRef = useRef(codeSearchStr);
  const supplierSearchStrRef = useRef(supplierSearchStr);

  function makeFilter(
    _selectedCategory?: string,
    _selectedSubCategory?: string
  ) {
    const queryFilter: IFoulLetterFilterViewModel = {};

    const productSearchStrCurrent = productSearchStrRef.current;
    const codeSearchStrCurrent = codeSearchStrRef.current;
    const supplierSearchStrCurrent = supplierSearchStrRef.current;

    queryFilter.code = codeSearchStrCurrent;
    queryFilter.productOrSubstance = productSearchStrCurrent;
    queryFilter.supplier = supplierSearchStrCurrent;

    setTableFilter((filters: any) => ({ ...filters, ...queryFilter }));
    setCurrentPage(0);
  }

  useEffect(() => {
    productSearchStrRef.current = productSearchStr;
  }, [productSearchStr]);

  useEffect(() => {
    codeSearchStrRef.current = codeSearchStr;
  }, [codeSearchStr]);

  useEffect(() => {
    supplierSearchStrRef.current = supplierSearchStr;
  }, [supplierSearchStr]);

  useEffect(() => {
    addKeyPressListener(randomTableSearchId, makeFilter);

    return () => {
      removeKeyPressListener(randomTableSearchId, makeFilter);
    };
  }, []);

  return (
    <Row
      id={randomTableSearchId}
      className="mt-4 align-center flex-md-column align-md-none flex-wrap justify-md-none bg-white px-3 py-3"
      style={{ borderRadius: '10px 10px 0px 0px' }}
    >
      <Column className="mr-2 mr-md-0 flex-1 w-md-5">
        <Text className="mb-1 color-blue-gray" size={15} weight="bold">
          Filtro
        </Text>
      </Column>
      <Column className="mr-2 mr-md-0 flex-2 w-md-100 mb-md-3">
        <Row className="flex-1">
          <input
            value={codeSearchStr}
            onChange={(e) => setCodeSearchStr(e.target.value)}
            type="text"
            className="flex-1"
            placeholder="Código"
          />
        </Row>
      </Column>
      <Column className="mr-2 mr-md-0 flex-3 w-md-100 w-20 mb-md-3">
        <Row className="flex-1">
          <input
            value={productSearchStr}
            onChange={(e) => setProductSearchStr(e.target.value)}
            type="text"
            className="flex-1"
            placeholder="Produto ou substância"
          />
        </Row>
      </Column>

      <Column className="mr-2 mr-md-0 flex-3 w-md-100 w-20 mb-md-3">
        <Row className="flex-1">
          <input
            value={supplierSearchStr}
            onChange={(e) => setSupplierSearchStr(e.target.value)}
            type="text"
            className="flex-1"
            placeholder="Fornecedor"
          />
        </Row>
      </Column>
      <Column className="mr-2 mr-lg-0 flex-1 w-md-100 ">
        <Row>
          <Button
            tabIndex={0}
            className="focus-button"
            width="auto"
            onClick={makeFilter}
          >
            <img src={IconSearch} alt="" />
          </Button>
        </Row>
      </Column>
    </Row>
  );
};

export default MissingLetterSearch;
